module.exports = "/_next/static/images/46fe5238a73791b7a1c9b20b24dcc7cc-sanpablo-2-desktop.jpg";